
import WebFont from 'webfontloader'

const options = {"google":{"families":["Noto+Sans+TC:300,400,500,700&display=swap"]}}

WebFont.load(options)
